import { Outlet } from '@buzola/router'
import { Toaster } from '~/lib/toast'

export default function RootLayout() {
	return (
		<Toaster>
			<Outlet />
		</Toaster>
	)
}
